import { DislikedMealsResponse } from "@/clients/models/DislikedMealsResponse";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetDislikedMeals = () => {
  const { data, isLoading, error, refetch, isRefetching, isError } =
    useQuery<DislikedMealsResponse>({
      queryKey: [QueryKeys.DISLIKED_MEALS],
      queryFn: async () => {
        const user = guardGetUserFromLocalStorage();
        const { data } = await MealsService.getDislikedMealsApiV1MealsDislikedGet(user.id);
        return data;
      },
    });

  const meals = data?.meals ?? [];
  const dislikedMealsSet = useMemo(() => {
    const ids = meals.map((meal) => meal.id ?? "").filter((id): id is string => Boolean(id));
    return new Set(ids);
  }, [meals]);

  return {
    dislikedMealsResponse: data,
    dislikedMeals: meals,
    dislikedMealsSet,
    isDislikedMealsLoading: isLoading,
    isRefetching,
    isError,
    error,
    refetch,
  };
};
